export default {
	name: 'DeviceOffline',
	created() {
		this.timer = setInterval(this.retry, 1000);
		this.link = '/mgm?' + this.$route.params.deviceReference;
	},
	data() {
		return {
			timer: '',
			retryTimer: 15,
			link: ''
		};
	},
	methods: {
		retry() {
			this.retryTimer--;
			if (this.retryTimer === 0) {
				this.reload();
			}
		},
		reload() {
			window.location.replace(this.link);
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
	}
};



// WEBPACK FOOTER //
// ./app/components/device-offline/script.js